import styles from './pressable.module.scss';
export var pressableClass = styles.pressable;